// React
import { Fragment } from 'react';

// Components
// Hooks
import type { SingleKeyAction } from '@/utils/hooks/homeKeyActions/useKeyActions';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { ActionLink } from './actionLink';

type DualActionsItemProps = {
    is_displayed: boolean;
    actions: SingleKeyAction[];
};
export const DualActionsItem = ({ actions, is_displayed }: DualActionsItemProps) => {
    const { t: tHome } = useTranslation('home');

    return (
        is_displayed && (
            <div className="flex flex-col justify-between rounded-xl bg-white transition duration-200 dark:bg-icoDarkMode-anthracite">
                {actions.map((action, index) => (
                    <Fragment key={action.type}>
                        <ActionLink
                            onClick={action.onClick}
                            title={tHome(action.title)}
                            icon={action.icon}
                            hoverIcon={action.hoverIcon}
                        />
                        {index < actions.length - 1 && (
                            <hr className="w-full border-icoGray-300 dark:border-icoDarkMode-beton" />
                        )}
                    </Fragment>
                ))}
            </div>
        )
    );
};
